import formatName from 'I18n/utils/formatName';
import { getFirstName, getLastName, getId, getEmail
// @ts-expect-error module not typed
} from 'conversations-internal-schema/sales-users/operators/salesUsersGetters';
import Raven from 'raven-js';
import { HS_INTERNAL_USER_ID, HS_OUT_OF_OFFICE_HOURS } from 'routing-ui/working-hours/constants';
const getUserOutOfOfficeHours = crmResponse => {
  const map = new Map();
  crmResponse.results.forEach(user => {
    const userId = user.properties[HS_INTERNAL_USER_ID];
    const property = user.properties[HS_OUT_OF_OFFICE_HOURS];
    if (userId && property) {
      try {
        const outOfOfficeHours = JSON.parse(property);
        map.set(userId, outOfOfficeHours);
      } catch (e) {
        Raven.captureException(e);
      }
    }
  });
  return map;
};
export const mapUsersResponseToAtMentionUsers = (usersResponse, crmResponse) => {
  const {
    adminUsers = [],
    freeUsers = [],
    routableUsers = []
  } = usersResponse || {};
  const userOutOfOfficeMap = getUserOutOfOfficeHours(crmResponse);
  const uniqueUsers = [...adminUsers, ...freeUsers, ...routableUsers].reduce((accumulator, user) => accumulator[getId(user)] ? accumulator : Object.assign({}, accumulator, {
    [getId(user)]: user
  }), {});
  return Object.keys(uniqueUsers).reduce((accumulator, userId) => {
    const user = uniqueUsers[userId];
    const outOfOfficeHours = userOutOfOfficeMap.get(userId);
    const userOption = Object.assign({
      value: getEmail(user),
      text: formatName({
        firstName: getFirstName(user),
        lastName: getLastName(user)
      }),
      id: getId(user)
    }, outOfOfficeHours ? {
      outOfOfficeHours
    } : {});
    return [...accumulator, userOption];
  }, []);
};